import { FormField, FormItem, FormMessage } from "@patient-watch/ui/form";
import { useId } from "react";
import { useFormContext } from "react-hook-form";
import { ChoiceCard } from "./components/ChoiceCard";
import { ChoiceGroup } from "./components/ChoiceGroup";

interface Props {
    name: string;
    label: string;
    caption?: string;
    description?: string;
    required?: boolean;
}

const OPTIONS = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
];

const YesNo: React.FC<Props> = ({ name, label, caption, description, required = false }) => {
    const { control } = useFormContext();
    const labelId = `${useId()}-label`;
    const hasQuestionLabel = label.trim().length > 0;

    return (
        <FormField
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <FormItem>
                    <ChoiceCard
                        labelId={labelId}
                        caption={caption}
                        label={label}
                        required={required}
                        description={description}
                        invalid={fieldState.invalid}
                    >
                        <ChoiceGroup
                            name={name}
                            options={OPTIONS}
                            value={field.value}
                            onChange={(next) => field.onChange(next)}
                            invalid={fieldState.invalid}
                            labelledBy={hasQuestionLabel ? labelId : undefined}
                            tabEachOption
                            data-testid={`form-options-${name}`}
                        />
                        <FormMessage />
                    </ChoiceCard>
                </FormItem>
            )}
        />
    );
};

export default YesNo;
